import { useEffect, useState } from 'react';

// useIsMobile: matchMedia em vez de window.innerWidth pra ser confiavel
// dentro do webview do WhatsApp Business no iOS, que em alguns dispositivos
// reportava innerWidth errado no primeiro paint e travava o layout em modo
// desktop dentro de um viewport mobile — Sider fixo de 230px comendo o
// Content e virando coluna de texto empilhado.
export default function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(query);
    const update = () => setIsMobile(mq.matches);
    update();
    // WebViews lentos as vezes reportam dimensoes so depois do primeiro paint,
    // entao re-checa apos 300ms pra pegar o valor definitivo.
    const t = setTimeout(update, 300);
    if (mq.addEventListener) {
      mq.addEventListener('change', update);
      return () => { clearTimeout(t); mq.removeEventListener('change', update); };
    }
    // Safari <14 usa API antiga
    mq.addListener(update);
    return () => { clearTimeout(t); mq.removeListener(update); };
  }, [query]);

  return isMobile;
}
